import React, { useEffect, useState } from "react";
import { GetAdminUsers } from "../../../api";

const OrganizationRowData = ({
    isPcAdmin,
    user,
    listOrganizations,
    addResidueModal,
    onEditClick,
    listOrganizationUsers,
    addMember,
    confirmModel,
}) => {
    const [relationShipManagers, setRelationShipManagers] = useState([]);
    const count = localStorage.getItem("counter")
        ? localStorage.getItem("counter")
        : "";
    const bindUsersCount = (organization_id) => {
        const memberCount = listOrganizationUsers.filter(
            (x) => x.organization_id === organization_id,
        );
        return memberCount ? memberCount.length : 0;
    };

    useEffect(() => {
        GetAdminUsers()
            .then((response) => {
                if (response.success) {
                    const users = response.users;
                    setRelationShipManagers(users);
                }
            })
            .catch((error) => console.log(error));
    }, []);

    const bindMainAdmin = (main_admin_id) => {
        if (main_admin_id) {
            const mainAdmin = listOrganizationUsers.find(
                (x) => x.id === main_admin_id,
            );
            return mainAdmin ? mainAdmin.name : "-";
        } else {
            return "-";
        }
    };

    const bindOrgType = (type) => {
        switch (type) {
            case "hands_on":
                return "Agent";
                break;
            case "hands_off":
                return "Referral Partner";
                break;
            default:
                return "-";
                break;
        }
    };

    const bindRelationShipManager = (primary_contact_id) => {
        if (primary_contact_id) {
            const primaryContact = relationShipManagers.find(
                (x) => x.id === primary_contact_id,
            );
            return primaryContact ? primaryContact.name : "-";
        } else {
            return "-";
        }
    };
    const addDefaultSrc = (ev) => {
        ev.target.src = "/img/pwz/logo-solid.png";
    };

    return (
        <>
            {listOrganizations &&
                listOrganizations.length > 0 &&
                listOrganizations.map((organizationData, index) => (
                    <tr key={index}>
                        <td onClick={(evt) => onEditClick(organizationData.id)}>
                            {organizationData.id}
                        </td>
                        <td onClick={(evt) => onEditClick(organizationData.id)}>
                            <div className="orglogo">
                                <img
                                    onError={(evt) => addDefaultSrc(evt)}
                                    className="organisationLogo"
                                    src={
                                        "/img/" +
                                        organizationData.whitelabel_slug +
                                        "/logo-solid.png?" +
                                        count
                                    }
                                    alt={"org-logo"}
                                />
                            </div>
                        </td>
                        <td onClick={(evt) => onEditClick(organizationData.id)}>
                            <div className="org-name">
                                <div className="org-full-name">
                                    <h4>{organizationData.name}</h4>
                                    <br />
                                    <div className="add-org">
                                        <div className="addman">
                                            <span className="ttladduser">
                                                <img src="/images/aduser.png " />
                                            </span>
                                            <span className="ttlorg">
                                                {organizationData.members_count}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td
                            className="contactTd"
                            onClick={(evt) => onEditClick(organizationData.id)}
                        >
                            <p>{organizationData.leads_last_month}</p>
                        </td>
                        <td
                            className="contactTd"
                            onClick={(evt) => onEditClick(organizationData.id)}
                        >
                            <p>{organizationData.approval_last_month}</p>
                        </td>
                        <td
                            className="contactTd"
                            onClick={(evt) => onEditClick(organizationData.id)}
                        >
                            <p>{organizationData.approval_life_of_orgs}</p>
                        </td>
                        <td>
                            <p>{bindMainAdmin(organizationData.main_admin)}</p>
                        </td>
                        <td>
                            <p>
                                {relationShipManagers &&
                                    relationShipManagers.length > 0 &&
                                    bindRelationShipManager(
                                        organizationData.primary_contact_id,
                                    )}
                            </p>
                        </td>
                        <td>
                            <p>{bindOrgType(organizationData.type)}</p>
                        </td>
                        <td className="addresidual">
                            {isPcAdmin && (
                                <span
                                    onClick={(evt) =>
                                        addResidueModal(organizationData.id)
                                    }
                                >
                                    - Add residual
                                </span>
                            )}
                            {user.role === "admin" && (
                                <span
                                    onClick={(evt) =>
                                        addMember(organizationData.id)
                                    }
                                    className="addresidualIMG"
                                >
                                    <img src="/images/add-user.svg " />
                                </span>
                            )}
                            {isPcAdmin && (
                                <span
                                    onClick={(evt) =>
                                        confirmModel(organizationData.id)
                                    }
                                    className="deleteOrgIMG addresidualIMG"
                                >
                                    <img src="/images/delete-org.svg " />
                                </span>
                            )}
                        </td>
                    </tr>
                ))}
        </>
    );
};

export default OrganizationRowData;
